import React from 'react';
import { Container, Box, ClassNameMap } from '@mui/material';
import { makeStyles } from 'tss-react/mui';


export type RematchingContainerProps = { classes?: ClassNameMap<'container' | 'content'> };


const useRematchingContainerStyles = makeStyles<RematchingContainerProps>()(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(5),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(10),
    }
  },

  content: {
    maxWidth: '588px',
    width: '100%',
  },
}));


export const RematchingContainer: React.FC<RematchingContainerProps> = (props) => {
  const { classes } = useRematchingContainerStyles(props, { props });

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container className={classes.container}>
      <Box className={classes.content}>
        {props.children}
      </Box>
    </Container>
  );
};
